var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatternEight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 250,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F87C56",
    d: "M347.5 158.887h-18v91h18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M745.5 91.36H518.324V17.924a.282.282 0 00-.084-.2.283.283 0 00-.201-.084H403.992V0h114.047a17.944 17.944 0 0117.924 17.923v55.799H745.5V91.36zM396.565 66.904h72.229a17.63 17.63 0 0017.612-17.612V24.838H354.249l-.194 107.853h-7.096V24.838H0v17.64h329.32V150.33h42.342l.194-107.853h96.911v6.787h-89.672l-1.042 108.549H329.32v17.639h66.204l1.041-108.55zM745.5 98.293H421.631l-.118-6.912h89.728V24.803h-17.639v48.94H403.57l.721 42.189H745.5V98.293z",
    fill: "#F87C56"
  })));
}
export default SvgIconPatternEight;